import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';

@Component<PageHeader>({
  components: {
    'mi-breadcrumbs': Breadcrumbs,
  },
})
export default class PageHeader extends Vue {
  @Prop({ default: '' })
  protected pageTitle!: string;
  @Prop({ default: '' })
  protected avatar!: string;

  @Model('breadcrumbs') breadcrumbs!: Object[];
}
